(function () {
  document.documentElement.classList.add('zv-anim-ready');

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var main = document.querySelector('main') || document.body;

    // Reveal each homepage/page section as it scrolls into view.
    var sections = main.querySelectorAll('.shopify-section');
    sections.forEach(function (sec, i) {
      if (i === 0) return; // let the first section (hero) show immediately
      sec.classList.add('zv-reveal');
      sec.style.setProperty('--zv-i', 0);
    });

    // Stagger cards/rows inside flex or grid groups (testimonials, checklists, stats),
    // skipping the hero (first section), which should be visible immediately.
    var firstSection = sections[0];
    var groupChildren = main.querySelectorAll(
      '.media-with-content__content > .group-block-content > *, ' +
        '#shopify-section-section_testimonials .group-block-content > *'
    );
    groupChildren.forEach(function (el, i) {
      if (firstSection && firstSection.contains(el)) return;
      el.classList.add('zv-reveal');
      el.style.setProperty('--zv-i', i % 6);
    });

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.zv-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    document.querySelectorAll('.zv-reveal').forEach(function (el) {
      io.observe(el);
    });
  });
})();

/* Add-to-cart pill: shown only in sections that don't have their own CTA.
   It steps aside over the buy box, the comparison, the 7-day steps, the
   guarantee and the final CTA sections. */
(function () {
  function init() {
    var steps = document.querySelectorAll('[id$="__main"], [id$="section_compare"], [id$="section_steps"], [id$="section_guarantee_pdp"], [id$="section_final_cta"]');
    if (!steps.length) return;
    var scroller = document.querySelector('.page-wrapper');
    var ticking = false;
    function check() {
      ticking = false;
      var vh = window.innerHeight, over = false;
      steps.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > vh - 100) over = true;
      });
      document.body.classList.toggle('zv-sticky-hide', over);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* After the theme's own add-to-cart succeeds on the product page (main button or
   sticky bar), send the customer straight to checkout. The add itself is untouched. */
(function () {
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (!e || e.action !== 'add' || e.context !== 'product' || !e.promise) return;
    e.promise.then(function (res) {
      var d = res && res.detail;
      if (d && !d.didError) window.location.href = '/checkout';
    }).catch(function () {});
  });
})();
